import { StyledDialog, StyledDialogActions, StyledDialogContent, StyledDialogTitle } from 'layout/StyledDialog'
import { Button, ComponentVersionsInherit, ComponentVersions_3_0, Typography } from 'opensolar-ui'
import { useTranslate } from 'ra-core'

type ClearCartConfirmModalProps = {
  open: boolean
  itemCount: number
  onCancel: () => void
  onConfirm: () => void
}

export const ClearCartConfirmModal = ({ open, itemCount, onCancel, onConfirm }: ClearCartConfirmModalProps) => {
  const translate = useTranslate()

  return (
    <ComponentVersionsInherit versions={ComponentVersions_3_0}>
      <StyledDialog open={open} onClose={onCancel}>
        <StyledDialogTitle>{translate('Clear cart')}?</StyledDialogTitle>
        <StyledDialogContent>
          <Typography textVariant="body1">
            {translate('You are about to remove %{count} items from your cart', { count: itemCount })}
          </Typography>
        </StyledDialogContent>
        <StyledDialogActions>
          <Button variant="contained" color="default" onClick={onCancel}>
            {translate('Cancel')}
          </Button>
          <Button variant="contained" color="primary" onClick={onConfirm}>
            {translate('Clear cart')}
          </Button>
        </StyledDialogActions>
      </StyledDialog>
    </ComponentVersionsInherit>
  )
}
